import axios from 'axios';
import store from '../../../app/store/store';
import { incrementLoading, decrementLoading } from '../../../app/store/slices/loadingSlice';

//const API_URL = 'http://localhost:5199/api/';
const API_URL = 'https://dev-billeur-api-webapp-f3cnbwfybmhdbjap.westeurope-01.azurewebsites.net/api/';

const authAxios = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,  // ✅ Always send/receive cookies
  timeout: 10000,
});

authAxios.interceptors.request.use(
  (config) => {
    // ✅ Increment global loading counter
    store.dispatch(incrementLoading());
    return config;
  },
  (error) => {
    console.error('❌ Auth Request Error:', error);
    // ✅ Decrement loading counter on error
    store.dispatch(decrementLoading());
    return Promise.reject(error);
  }
);

authAxios.interceptors.response.use(
  (response) => {
    // ✅ Decrement global loading counter on success
    store.dispatch(decrementLoading());
    return response;
  },
  (error) => {
    console.error('❌ Auth Response Error:', error.response?.status, error.response?.data);
    // ✅ Decrement global loading counter on error
    store.dispatch(decrementLoading());
    return Promise.reject(error);
  }
);

export default authAxios;